import React, { useState } from "react";
import { Button, Card, CardHeader, Col, Form, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Tag } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import HeadInspection from "../components/InfoInspection";
import InspectionItem from "../components/InspectionItem";
import '../utils/detailInsp.css'
import { formatDate } from "../../../Components/Common/FormatDate/FormatDate";

const DetailInspection = ({ modal, toggle, selectedInspection }) => {
  document.title = `Inspections | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [showAll, setShowAll] = useState(false);

  const vehicleInspection = selectedInspection?.vehicle || {};
  const inspections = selectedInspection?.revisions || [];
  const goodInspections = inspections.filter(inspection => inspection.status === "Oui").length || 0;

  const inspectionsToDisplay = showAll ? inspections : inspections.slice(0, 3);
  console.log('selectedInspection', selectedInspection)

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "1200px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Détail de l'inspection du véhicule {vehicleInspection?.registrationNumber || ""} de {selectedInspection?.userName || ""}
      </ModalHeader>
      <Form>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <Tag color="#92c6caff" style={{ fontSize: '16px', padding: '8px 16px' }}>
                Période de l'inspection : Du {formatDate(selectedInspection?.createdAt, true)  || "-"} au { formatDate(selectedInspection?.resolvedDate, true) || "-"}
              </Tag>
            </Col>
            <Col lg={12}>
              <HeadInspection vehicleInspection={vehicleInspection} />
            </Col>
          </Row>
          <Row>
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Les médias liés à cette inspection</h5>
                  <h5>Performance <Tag color="cyan">{goodInspections}/{inspections.length}</Tag></h5>
                </div>
              </CardHeader>
            </Card>

            {inspections.length > 0 ? (
              <>
                <TransitionGroup component={null}>
                  {inspectionsToDisplay.map((inspection) => (
                    <CSSTransition
                      key={inspection.id}
                      timeout={300}
                      classNames="inspection"
                    >
                      <Col lg={4}>
                        <InspectionItem inspection={inspection} />
                      </Col>
                    </CSSTransition>
                  ))}
                </TransitionGroup>

                {inspections.length > 3 && (
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <Button color="link" onClick={() => setShowAll(!showAll)} className="mb-2">
                      {showAll ? (
                        <>
                          Voir moins <ArrowUpOutlined />
                        </>
                      ) : (
                        <>
                          Voir plus... <ArrowDownOutlined />
                        </>
                      )}
                    </Button>
                  </Col>
                )}
              </>
            ) : (
              <Col lg={12}>
                <div>Aucune inspection disponible pour le moment</div>
              </Col>
            )}
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default DetailInspection;


